import { ArrowLeft} from 'lucide-react';
import { useState } from 'react';
import { RadioListItem } from './RadioListItem';
import { FormButton } from './FormButton';

type VerificationMethod = 'phone' | 'email';

interface VerificationSecurityScreenProps {
  onBack: () => void;
  onContinue: (method: VerificationMethod) => void;
  phone?: string;
  email?: string;
}

export const VerificationSecurityScreen = ({
  onBack,
  onContinue,
  phone = '+52 *** *** 5678',
  email = 'a***@example.com',
}: VerificationSecurityScreenProps) => {
  const [selectedMethod, setSelectedMethod] = useState<VerificationMethod>('phone');
  const [loading, setLoading] = useState(false);

  const handleSendCode = () => {
    setLoading(true);
    // Simulate API call
    setTimeout(() => {
      setLoading(false);
      onContinue(selectedMethod);
    }, 1500);
  };

  return (
    <div className="min-h-screen bg-[#F7F8FA]">
      {/* Header */}
      <div className="bg-white border-b border-[#E5E7EB] sticky top-0 z-10">
        <div className="flex items-center gap-3 p-4">
          <button
            onClick={onBack}
            className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-[#F7F8FA] transition-colors"
          >
            <ArrowLeft className="w-6 h-6 text-[#111827]" />
          </button>
          <h1 className="text-lg font-bold text-[#111827]">Verificación de seguridad</h1>
        </div>
      </div>

      {/* Content */}
      <div className="p-4 space-y-6">
        <div>
          <p className="text-sm text-[#6B7280]">
            Elige cómo quieres verificar tu identidad
          </p>
        </div>

        <div className="bg-white rounded-[16px] border border-[#E5E7EB] overflow-hidden divide-y divide-[#E5E7EB]">
          <RadioListItem
            title="OTP por teléfono"
            subtitle={phone}
            selected={selectedMethod === 'phone'}
            onClick={() => setSelectedMethod('phone')}
          />
          <RadioListItem
            title="OTP por correo"
            subtitle={email}
            selected={selectedMethod === 'email'}
            onClick={() => setSelectedMethod('email')}
          />
        </div>

        <FormButton
          onClick={handleSendCode}
          loading={loading}
        >
          {loading ? 'Enviando…' : 'Enviar código'}
        </FormButton>
      </div>
    </div>
  );
};
